import React, { Component } from 'react';
import {
  imageBasePath,
  mobileButtonDim,
} from '../../library/constants';
import './index.css';
import {
  isMobilePhone, isMobileTablet
} from '../../library/calc';
export class HelpIcon extends Component {

  clickOrTouch(){

    if(isMobilePhone()){

      this.props.hideNotificationModal({});
      const screenIsOn = `navLegendFromTree`;
      this.props.setFlipCardScreenIsOn({screenIsOn});
      this.props.showMobileFlipCard();

    } else{

      this.props.setShowLegendModal(true);
    }
  }

  render () {
    const {
      // toggleProductTour,
      // setShowLegendModal,
      canvasHeight,
    } = this.props;

    const posOfGearIcon = canvasHeight + this.props.canvasTop - 380 + (this.props.canvasTop * -1);
    let helpStyle = {
      top: `${ posOfGearIcon - 45 }px`,
      left: '56px',
      background: `url(${imageBasePath}helpIcon.svg) no-repeat `,
      backgroundSize: 'contain',
      width: '27px',
      height: '27px',
      position: 'absolute',
      cursor: 'pointer',
      opacity: .5,
    };

    if( this.props.stageBackgroundCustomColor === '#000000'){
      helpStyle = {...helpStyle, ...{
        background: `url(${imageBasePath}helpIcon_blk_bg.svg) no-repeat `,
        opacity: .7,
      }};
    }

    if(isMobileTablet()){
      helpStyle.top = `${ canvasHeight - 157 }px`;
      helpStyle.left = '43px';
    }

    if(isMobilePhone()){
      helpStyle.top = `${ this.props.canvasHeight - ( this.props.chartType === 'fan' ? 120: 170) }px`;
      helpStyle.left = `10px`;
      helpStyle.width = `${mobileButtonDim}px`;
      helpStyle.height = `${mobileButtonDim}px`;
      helpStyle.backgroundSize = `${mobileButtonDim}px ${mobileButtonDim}px`;
      helpStyle.opacity = .4;
    }

    return (
      <div className="desktopBoxControls">
        <div id="productTourIcon" style={{
            ...helpStyle,
            background: `${ ( isMobileTablet() ? 'transparent': 'white')}`,
          }} >
          <div
            style={{
              ...helpStyle,
              top: '0px',
              left: '0px',
            }}
            onTouchStart={
              ()=>{
                this.clickOrTouch()
                // toggleProductTour({fromWhere: 'productTourIcon onTouchStart'});
              }
            }
            onClick={
              ()=>{
                this.clickOrTouch()
                // toggleProductTour({fromWhere: 'productTourIcon onClick'});
              }
            }
            >
          </div>
        </div>
      </div>
    );
  }
}

